module.exports = __webpack_public_path__ + "img/bzb.1cbcef02.png";